import { useTheme } from '@cdl/heartbeat-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { leadNamesSelector } from '../../ecg/selectors/signal.selectors';
import { updatedWaveListSelector } from '../../wave/selectors/wave.selectors';
import { Column } from '../contexts/column.context';
import { Row } from '../contexts/row.context';
import { STRIP_WIDTH, TOP_PLOT_FOOTER_HEIGHT } from '../utils/graph.utils';
import { getNoiseSegments, Noise } from '../utils/noise.utils';
import { StripContent } from './StripContent';
import { StripPosition } from './StripPosition';
import { StripSquare } from './StripSquare';

const NOISE_BAR_HEIGHT = TOP_PLOT_FOOTER_HEIGHT / 3;

interface Props {
  offset?: number;
}

export const NoiseBar: React.FC<Props> = ({ offset }) => {
  const theme = useTheme();
  const waves = useSelector(updatedWaveListSelector);
  const leads = useSelector(leadNamesSelector);
  const segments = getNoiseSegments(waves, leads);

  return (
    <Row height={NOISE_BAR_HEIGHT}>
      <Column width={STRIP_WIDTH} offsetLeft={offset}>
        <StripContent>
          <StripPosition>
            {segments.map((segment, index) => (
              <StripSquare
                key={index}
                onset={segment.start}
                offset={segment.end}
                main={{
                  style: { cursor: 'default' },
                  fill:
                    segment.type === Noise.disabling
                      ? 'grey'
                      : segment.type === Noise.ok
                      ? 'lightgray'
                      : theme.colors.neutral[0],
                }}
              />
            ))}
          </StripPosition>
        </StripContent>
      </Column>
    </Row>
  );
};
